export enum Check {
  FINGER_TEST = 1,
  COLOR_TEST,
  IDENTITY_INFO,
  SOCIAL_INFO,
  FINANCIAL_RISK,
  ENGLISH,
  CHINESE,
  GAME,
  DIMENSION,
  DISC,
  BIG_FIVE_240,
  BIG_FIVE_60,
  DVF
}
